import * as React from "react";
function SvgWeddingRings(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={10}
        cy={16}
        r={9}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M13 11.87c0 2.71 1.54 6 4.28 8.78 4.24 4.29 9.79 5.64 12.39 3s1.27-8.25-3-12.54A14.76 14.76 0 0019.79 7"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgWeddingRings);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
